import { render, staticRenderFns } from "./date.vue?vue&type=template&id=417ef1c9&"
import script from "./date.vue?vue&type=script&lang=js&"
export * from "./date.vue?vue&type=script&lang=js&"
import style0 from "./date.vue?vue&type=style&index=0&id=417ef1c9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconCalendar: require('/opt/yamal.ru/src/components/icon/calendar.vue').default,RzPriceCalendar: require('/opt/yamal.ru/node_modules/razlet-ui/src/components/price-calendar/index.vue').default,RzButton: require('/opt/yamal.ru/node_modules/razlet-ui/src/components/button/index.js').default,BaseBottomBar: require('/opt/yamal.ru/src/components/base/bottom-bar.vue').default})
